export default "__VITE_ASSET__30545d69__"